export default function FeeTableAlt({ translate, lang }) {
	return (
		<table style={{ marginTop: "15px" }}>
			<thead>
				<tr>
					<th style={{ lineHeight: "20px" }}>
						{translate(
							lang,
							`3 de octubre - Diamante Cabo San Lucas`,
							`3 de octubre - Diamante Cabo San Lucas`,
						)}
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td className="center">
						{translate(lang, `MX$1,200.00`, `MX$1,200.00`)}
					</td>
				</tr>
			</tbody>
		</table>
	);
}
